import React from "react";
import "./DrawerMenu.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  generateOTPSuccess,
  fetchBill,
  logoutSuccess,
} from "../../redux/action";

const DrawerMenu = ({ isOpen, onClose }) => {
  const { restaurant, id, table } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function logout() {
    const allowedKeys = [
      "customer_portal_theme",
      "showBannerInLoginPage",
      "customer_portal_branch_id",
      "packageType",
    ];

    // 1. Clean SessionStorage (Yahan aapka theme data hai)
    Object.keys(sessionStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) {
        sessionStorage.removeItem(key);
      }
    });

    // 2. Clean LocalStorage (Yahan aapke tokens/user data hain)
    Object.keys(localStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) {
        localStorage.removeItem(key);
      }
    });

    // sessionStorage.clear();
    //  localStorage.clear();
    dispatch(logoutSuccess());
    navigate(`/${restaurant}/${id}/${table}`);
    //  navigate(`/engineer's kitchen/234ererw-12/23`);
  }

  function goToProfile() {
    onClose(); // close drawer
    navigate(`/${restaurant}/${id}/${table}/profile`);
  }

  function goToHomePage() {
    onClose(); // close drawer
    navigate(`/${restaurant}/${id}/${table}/menu`);
  }

  return (
    <div className={`drawer-overlay ${isOpen ? "open" : ""}`} onClick={onClose}>
      <div
        className="drawer"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        {/* <div className="drawer-header"> */}
        <div>
          <h3>{restaurant}</h3>
          <button className="close-btn round-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="drawer-items">
          <button className="drawer-item" onClick={goToHomePage}>
            Home
          </button>
          <hr />
          <button className="drawer-item" onClick={goToProfile}>
            Profile
          </button>

          <hr />

          <button onClick={logout} className="drawer-item logout">
            Logout
          </button>
        </div>

        <div className="sidebar-footer">Powered by ARK tech</div>
      </div>
    </div>
  );
};

export default DrawerMenu;
